import { render, staticRenderFns } from "./DeviceAlarm.vue?vue&type=template&id=995e1310&"
import script from "./DeviceAlarm.vue?vue&type=script&lang=js&"
export * from "./DeviceAlarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports